module.exports = __webpack_public_path__ + "img/dynamicsOfMachinery_sign.51e7e051.png";